<template>
    <div class="my-3">
        
        <b-row v-if="!!showCharts">
            <b-col cols="12" md="4">
                <app-pie-chart
                    title="PQR's por Tipo"
                    :chart-data="byType"
                ></app-pie-chart>
            </b-col>
            <b-col cols="12" md="4">
                <app-pie-chart
                    title="PQR's por Estado"
                    :chart-data="byStatus"
                ></app-pie-chart>
            </b-col>
            <b-col cols="12" md="4">
                <app-pie-chart
                    title="PQR's por Categoría"
                    :chart-data="byCategory"
                ></app-pie-chart>
            </b-col>
        </b-row>
    </div>
</template>
<script>

import reportingRepository from '../../../../../../repositories/reporting.repository';
import PieChart from '../../../../Charts/PieChart';
import { processByType, processByStatus, processByCategory } from '../../processDataFunctions';
export default {
    components: {        
        appPieChart: PieChart,
    },
    props: ['selectedClient', 'year', 'month'],
    data: () => ({
        byType: [],
        byStatus: [],
        byCategory: [],
        showCharts: false
    }),
    methods: {
        async loadClientIndicators() {
            if(!this.selectedClient) return toastr.error('No hay un cliente seleccionado');
            try {
                const rr = {...reportingRepository};
                const {data} = await rr.getPqrClientIndicators(this.selectedClient.id, this.year, this.month);

                this.showCharts = true;
                this.byType = processByType(data.byType);
                this.byStatus = processByStatus(data.byStatus);
                this.byCategory = processByCategory(data.byCategory);
            } catch(err) {
                toastr.error(`Ocurrió un error al cargar los indicadores del cliente [${err.message}]`);
            }
        }
    },
    created() {
        this.$bus.$on('pqr-client-charts.load', this.loadClientIndicators);
    },
    beforeDestroy() {
        this.$bus.$off('pqr-client-charts.load');
    }
}

</script>